const $ = require('jquery');
const urllib = require('url');
import run from '../../utilities/run';
import render from "../../utilities/render";
import {isPresent} from "../../utilities/general";
import { createPreventDefault } from '../../utilities/general';
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import EditChecker from '../../components/EditChecker/EditChecker';
import { SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, SUCCESS_MODAL_TIMEOUT } from "../../constants";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
import {buildExport,prepareDataToSendController,isEdit,doAjax,pushFilterSessionCacheState,isNew,isDeleteView,isOnlyLookupDataUpdate,retriveCriteriaObjectByOperation} from "../../utilities/filtersutil";
const _ = require("underscore");
const modalHtml = require("../../sharedHtml/modal.html");
const targetSelector = "#fixitorder-details";
let els = {};
const elsModal = {};
const elsModalMap = {};
const elsMap = {
	 createNewListModalCall:$("#create-new-list-modal-call")
    ,maintainNewErrorModal: $("#maintain-add-new-error-modal")
	,errCodeField:$("#errCode")
	,errTypeField:$("#errtype")
}


run(targetSelector,(mainEl) => {

	//Use this url to submit "New error" form data info to controller when user clicks on submit button on modal form.
	const saveNewErrorUrl = mainEl.data("savenewerror-url");
	const reqfieldsForErrorUrl = mainEl.data("reqfieldsurl-url");  //use this only to get the mandatory param values
	const getErrHistoryUrl = mainEl.data("errorhistory-url");

	//parse url to get mandatory param values
	const queryObject = urllib.parse(reqfieldsForErrorUrl, true).query;

	//capture details page url so that it can be used to reload after saving the error.
	const outerLocationUrl = location.href;

	var submitModalFlow = new SubmitModalFlow();
   	submitModalFlow.init();


 //when user clicks on "Add error" button on details page, this function will be called and loads form to add new error
  $(".create-new-error-modal-call").click(function (event) {
	  event.preventDefault();

	  clearErrorOnSave();

	  $("#errorModalTitle").text("Add Error");
	  $("#currentevent").val("adderror");
	  $("#oreId").val(queryObject._fixit_WAR_releaseorderportlet_oreId);
	  $("#oreVzwOrder").val(queryObject._fixit_WAR_releaseorderportlet_oreVzwOrder);
	  $("#errHdrId").val(queryObject._fixit_WAR_releaseorderportlet_errHdrId);

	  //clear values and enable fields.
	  $("#errCode").attr('disabled', false);
	  $("#errtype").attr('disabled', false);
	  $("#errNote").val("");
	  $("#status option").each(function () {
		 if(this.value == 'OPEN'){
			 $(this).attr("selected", "selected");
            return;
		 }
      });
	  $("#status").val('OPEN');
	  $("#status").attr('disabled', true);
	  
	  $("#rslCode option").each(function () {		
		 if(this.value == 'DEFAULT'){
			$(this).attr("selected", "selected");
            return;
		 }
      });

	  $("#rslCode").val("DEFAULT");
	  $("#errtype").val("INTERFACE");
	  $("#errCode").val("I0001");
	  
	  $("#maintain-add-new-error-modal").modal("show");
  });


 //when user clicks on submit button on "Add error" popup form, this function will be called to save the data to ufix
  $(".submit-add-error-btn").click(function (event) {
	  event.preventDefault();
	  let proceed = "true";
	  let errTypeSel =  $("#errtype").val();
	  let errCodeSel =  $("#errCode").val();

	  //Only for new error, Validate user input for errorCode and errorType
	 if($("#currentevent").val() != undefined && $("#currentevent").val() == "adderror"){
	  if(errTypeSel == "INTERFACE" && errCodeSel.indexOf('W') >-1 ){
		proceed = "false";
		showErrorOnSave("Please select an Interface type Error");
	  }else if(errTypeSel == "WMS" && errCodeSel.indexOf('I') > -1){
		proceed = "false";
		showErrorOnSave("Please select an WMS type Error");
	  }else{
		proceed = "true";
		clearErrorOnSave();	
	  }
	} 

	//capture screen data
	  var reqData = {
        		"errtype": $("#errtype").val(),
                "errCode": $("#errCode").val(),
                "errCodeDesc":$("#errCode option:selected").text(),
				"rslCode": $("#rslCode").val(),
				"rslCodeDesc": $("#rslCode option:selected").text(),
                "errNote": $("#errNote").val(),
				"errStatus": $("#status").val(),
				"currentevent":$("#currentevent").val(),
				"oreId":$("#oreId").val(),
				"oreVzwOrder":$("#oreVzwOrder").val(),
				"errHdrId":$("#errHdrId").val()
      };

	  if(proceed == "true"){
		$.ajax({
					url: saveNewErrorUrl,
					type: 'POST',
					data: reqData,
					dataType: 'JSON',
					async: true,
					success: function(response){
						if(response.status == "SUCCESS"){
						$("#maintain-add-new-error-modal").modal("hide");
						submitModalFlow.showLoadingModal();

						location.href = outerLocationUrl;
						location.reload();//load the details page to display latest added error
							setTimeout(function () {
									submitModalFlow.hideAllModals();
						}, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

						submitModalFlow.showSuccessModal();
						}else{
							showErrorOnSave(response.errorMessage);
						}
					},error: function (response) {
						submitModalFlow.hideAllModals();
					}
		});
	}

  });

 //when user clicks on "Cancel" button on "Add Error" form of Details page.
  $(".cancel-adderror-modal-btn-with-inputs").click(function (event) {
	  event.preventDefault();
	$("#maintain-add-new-error-modal").modal("hide");
  });



  //when user clicks on "Edit error" button on details page inrow with specific error, this function will be called and loads form prepopulated with error info.
  $(".edit-error-modal-call").click(function () {
    var dtlErrorCnt = ($(this).attr('id')).replace("edit-error-modal-call","");

	  $("#currentevent").val("editerror");
	  $("#oreId").val(queryObject._fixit_WAR_releaseorderportlet_oreId);
	  $("#oreVzwOrder").val(queryObject._fixit_WAR_releaseorderportlet_oreVzwOrder);
	  $("#errHdrId").val(queryObject._fixit_WAR_releaseorderportlet_errHdrId);

	  var errTypeId = "#dtlerrType"+dtlErrorCnt;
	  const errTypeDivValue =($(errTypeId).html()).trim();
	  
	  var divValue;
	  var id = "#dtlerrCode"+dtlErrorCnt;
	  var selectedErrCode =($(id).html()).trim();	//ErrorCode with respect to editerror button selected by user.  
	 
	  //set ErrorType,ErrCode value and make them readonly
	  if(selectedErrCode != ""){

		 $("#errCode option").each(function () {
		  if(this.value === selectedErrCode){
			$(this).attr("selected", "selected");
            return;
		  }
         });
		 $("#errCode").attr('disabled', true);
		 $("#errCode").val(selectedErrCode);

		 //have the attribute selected.
		 $("#errtype option").each(function () {
			if(this.value == errTypeDivValue){
			  $(this).attr("selected", "selected");
			  return;
			}
		 });

		 if(errTypeDivValue == "INTERFACE"){
			$("#errtype").val("INTERFACE");
		 }else if(errTypeDivValue == "WMS"){
			$("#errtype").val("WMS");
		 }
		 
		 $("#errtype").attr('disabled', true);

	  }


	  id = "#dtlerrRsldesc"+dtlErrorCnt;
	  divValue =$(id).html();
	  //get the rslcode and set it
	  if(divValue == " "){
		  //set to default.
		  $("#rslCode").val("DEFAULT");
	  }else{
		  //set resolution to dropdown value
		  id = "#dtlerrRslcode"+dtlErrorCnt;
		  divValue =$(id).prop("class");
		  $("#rslCode").val(divValue);
	  }

	  //set comment value
	  id = "#dtlerrComment"+dtlErrorCnt;
	  divValue =$(id).html();
	  $("#errNote").val(divValue.trim()); //trimmed value populate.


	  //set status value
	  id = "#dtlerrStatus"+dtlErrorCnt;
	  divValue =$(id).html().trim();

	  $("#status").attr('disabled', false);
	  $("#status").val(divValue);
	  $("#status option").each(function () {
		    if(this.value == divValue){
				 $(this).attr("selected", "selected");
				return;
			  }
	  });

	  $("#errorModalTitle").text("Edit Error");

	  //now show the adderror modal window
	  $("#maintain-add-new-error-modal").modal("show");

});


//when use clicks on details button with respect to an error, display comments and resolution history info.
$(".error-history-modal-call").click(function () {
	var dtlErrorHisCnt = ($(this).attr('id')).replace("error-history-modal-call","");
});

function init() {
	setElements();
	//bindElements();
}

function setElements() {
	setElementsFromScope(els, elsMap, mainEl);
}

function showErrorOnSave(message){
    $("#save-error-div-text").text(message);
    $("#save-error-div").removeClass('hidden');
}

function  clearErrorOnSave() {
    $("#save-error-div-text").text("");
    $("#save-error-div").addClass('hidden');
}

function showErrorOnHistory(message){
    $("#save-errorhis-div-text").text(message);
    $("#save-errorhis-div").removeClass('hidden');
}
function  clearErrorOnHistory() {
    $("#save-errorhis-div-text").text("");
    $("#save-errorhis-div").addClass('hidden');
}


//when user clicks on "Details" button on details page inrow with specific error, this function will be called and loads form prepopulated with error history info.
  $(".error-history-modal-call").click(function () {
      var dtlErrorCnt = ($(this).attr('id')).replace("error-history-modal-call","");
	  var oreId= queryObject._fixit_WAR_releaseorderportlet_oreId;
	  var errHdrId= queryObject._fixit_WAR_releaseorderportlet_errHdrId;

	  //Get errorType from details page
	  var errTypeId = "#dtlerrType"+dtlErrorCnt;
	  var globalErrType =$(errTypeId).html();
	  
	  //Get errorCode from details page
	  var id = "#dtlerrCode"+dtlErrorCnt;
	  var globalErrCode =($(id).html()).trim();	//Get ErrorCode from Details page with respect to editerror button selected by user. 
	  
	  id = "#dtlerrDesc"+dtlErrorCnt;
	  var globalErrDesc = ($(id).html()).trim();
	  
	  //capture screen data
	  var reqData = {
                "oreId":$("#oreId").val(),
				"oreVzwOrder":$("#oreVzwOrder").val(),
				"errHdrId":$("#errHdrId").val(),
				"errCode": globalErrCode,
				"errType": globalErrType
      };

	  //make ajax call to get the history from UFIX service.

	  $.ajax({
        		url: getErrHistoryUrl,
        		type: 'POST',
        		data: reqData,
        		dataType: 'JSON',
        		async: true,
        		success: function(response){
					if(response.status == "SUCCESS"){
						var globalRslDesc= "";
						var bodyHtml = "";
						var uFixResponse = jQuery.parseJSON(JSON.stringify(response.data));
						$("#errorHisCode").text(globalErrType+"-"+globalErrDesc);

						 //build body starts
						 //if details array has errnotes array it means there are comments without resolution. display them first.

						if(uFixResponse.errorDetails != undefined && uFixResponse.errorDetails.length >0){
							(uFixResponse.errorDetails).forEach(errorinfo => {
							 //outer notes without resolution
							  if(errorinfo.errNotes != undefined){								
								  (errorinfo.errNotes).forEach(errorNote => {
									bodyHtml = bodyHtml+"<tr>";
									bodyHtml=bodyHtml+"<td>"+globalErrType+"</td>";
									bodyHtml=bodyHtml+"<td>"+globalErrDesc+"</td>";
									bodyHtml=bodyHtml+"<td></td>"; //ignore resolution
									bodyHtml=bodyHtml+"<td>"+errorNote.errNote+"</td>";
									bodyHtml=bodyHtml+"<td>"+errorNote.createdBy+"</td>";
									bodyHtml=bodyHtml+"<td>"+errorNote.createdTime+"</td>";
									bodyHtml=bodyHtml+"</tr>";
								  });
							  }

							 //in the outer section if resolution array exists prepare those rows also.
							  if(errorinfo.errResolution != undefined){
							  (errorinfo.errResolution).forEach(resolution => {
								globalRslDesc = resolution.rslDesc;
								//iterate through notes and form remaining html
								if(resolution.errNotes != undefined){									
								 (resolution.errNotes).forEach(rslErrorNote => {
									bodyHtml = bodyHtml+"<tr>";
									bodyHtml=bodyHtml+"<td>"+globalErrType+"</td>";
									bodyHtml=bodyHtml+"<td>"+globalErrDesc+"</td>";
									bodyHtml=bodyHtml+"<td>"+globalRslDesc+"</td>"; //ignore resolution
									bodyHtml=bodyHtml+"<td>"+rslErrorNote.errNote+"</td>";

									if(rslErrorNote.createdBy !=undefined){
										bodyHtml=bodyHtml+"<td>"+rslErrorNote.createdBy+"</td>";
									}else{
										bodyHtml=bodyHtml+"<td></td>";
									}
									if(rslErrorNote.createdTime !=undefined){
									bodyHtml=bodyHtml+"<td>"+rslErrorNote.createdTime+"</td>";
									}else{
									bodyHtml=bodyHtml+"</tr>";
									}

									});
								}

							  });
							}

							});
						}else{
							//no data to display
							showErrorOnHistory("No data found");
						}

						//build body ends

						$(".domain-table-tbody").empty().append(bodyHtml);


					}else{
        				showErrorOnHistory(response.errorMessage);
        			}
        		},error: function (response) {
					showErrorOnHistory(response.errorMessage);
                }
    });

	  $("#maintain-error-history-modal").modal("show");

});

//when user clicks on "Cancel" button on "Add Error" form of Details page.
  $(".cancel-error-history-modal-btn").click(function (event) {
	  event.preventDefault();
	  clearErrorOnHistory();
	  $(".domain-table-tbody").empty();
	$("#maintain-error-history-modal").modal("hide");
});


//Validate user selection to make sure error type and error match
$(document).on('change', '#errtype', function(){
	let errCodeSelected = $("#errCode option:selected").val();
	if(errCodeSelected != undefined){
		if(this.value == "INTERFACE" && errCodeSelected.indexOf('W') >-1 ){
			showErrorOnSave("Please select an Interface type Error");
		}else if(this.value == "WMS" && errCodeSelected.indexOf('I') > -1){
			showErrorOnSave("Please select an WMS type Error");
		}else{
			clearErrorOnSave();	
		}
	}
 });  

 //Validate user selection to make sure error type and error match
 $(document).on('change', '#errCode', function(){  
	let errTypeSelected = $("#errtype option:selected").val();
	
	if(errTypeSelected == "INTERFACE" && this.value.indexOf('W')>-1){
		showErrorOnSave("Please select an Interface type Error");
	}else if (errTypeSelected == "WMS" && this.value.indexOf('I')> -1){
		showErrorOnSave("Please select an WMS type Error");
	}else{
		clearErrorOnSave();	
	}

	
 });  


init();

});


// WEBPACK FOOTER //
// ./src/pages/fixitOrders/details.js